// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_iE","advertCardPhoto__image":"c-a_iF"};